import { useCreateCompany } from '@/services/mutations/company';
import { useNavigate } from 'react-router-dom';
import { CompanyForm } from './components/CompanyForm';

const CreateCompany = () => {
	const navigate = useNavigate();

	const onBack = () => navigate('/admin/empresas');

	// Utiliza a mutation de empresa que já mapeamos no service
	const { mutate, isPending } = useCreateCompany(() => onBack());

	const onSubmit = (body: Companies.Create) => {
		// Aqui você pode tratar a lógica de vincular plano se necessário
		mutate(body);
	};

	return (
		<section className="space-y-6 px-8 py-8">
			{/* Breadcrumb padrão do projeto */}
			<div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-stone-300">
				<span>EMPRESAS</span>
				<span className="text-stone-200">/</span>
				<span className="text-stone-900">NOVA EMPRESA</span>
			</div>

			<CompanyForm
				formTitle="Nova Empresa"
				onBack={onBack}
				onSubmit={onSubmit}
				isSubmitting={isPending}
			/>
		</section>
	);
};

export { CreateCompany };
